var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBtnGeofences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_btn_geofences",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Map",
    d: "M7.5,6.712c-4.135,0-7.5-1.57-7.5-3.5C0,1.816,1.773.556,4.518,0A39.575,39.575,0,0,0,7.5,3.462,39.234,39.234,0,0,0,10.481,0C13.227.556,15,1.817,15,3.212,15,5.142,11.635,6.712,7.5,6.712Z",
    transform: "translate(0 12.288)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5188,1656c0,3.7-6,9.75-6,9.75s-6-6.047-6-9.75a6,6,0,0,1,12,0Z",
    transform: "translate(-5176 -1650)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path-2",
    "data-name": "Path",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(3.5 3.5)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnGeofences);
export default __webpack_public_path__ + "static/media/ic_btn_geofences.c053340246a9219421e3f9e268255f21.svg";
export { ForwardRef as ReactComponent };